<dsp-content-card [types]="filterTypes$ | async" [loading]="loading$ | async">
  <ng-container *ngIf="!(isMobile$ | async)">
    <ng-container *dsp-content-filter>
      <atlas-field-select [widthValue]="270" [style.--radius-xsmall]="'4px'" *ngIf="(type$ | async) === 'price'"
        id="funds-select-input" [label]="'Select Your Option'" placeholder="Select" [multiselectable]="true"
        [options]="fundsOptions" [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [showSelectAll]="true"
        [checkbox]="true" (valueChange)="onChangeFunds($event)" [(ngModel)]="funds" [disabled]="!(showData$ | async)"
        [clearable]="false">
      </atlas-field-select>

      <atlas-field-select [widthValue]="270" [style.--radius-xsmall]="'4px'" *ngIf="(type$ | async) === 'unitPrice'"
        id="valuations-fund-select" [label]="'Select Your Option'" placeholder="Select" [multiselectable]="false"
        [options]="fundsOptionsForSingleSelect$ | async" [size]="(isMobile$ | async) ? sizeSmall : sizeMedium"
        (valueChange)="onChangeFund($event)" [(ngModel)]="fund" [disabled]="!(showData$ | async)" [clearable]="false">
      </atlas-field-select>
    </ng-container>
  </ng-container>

  <atlas-field-select [widthValue]="270" [fullWidth]="(isMobile$ | async)" [style.--radius-xsmall]="'4px'"
    *dsp-content-filter id="valuations-price-type-select" [label]="'Unit Price Type'" placeholder="Select"
    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [multiselectable]="false" [options]="prices"
    (valueChange)="onChangePrice($event)" [(ngModel)]="price" [disabled]="!(showData$ | async)" [clearable]="false">
  </atlas-field-select>

  <ng-container *ngIf="isMobile$ | async">
    <atlas-field [widthValue]="270" [fullWidth]="(isMobile$ | async)" *dsp-content-filter
      [id]="'valuations-as-at-filter'" [size]="(isMobile$ | async) ? sizeSmall : sizeMedium">
      <!-- <atlas-field-label className="typographyStyles-label-small">From</atlas-field-label> -->
      <atlas-field-label>As at</atlas-field-label>
      <input [(ngModel)]="asAt" atlasInput [min]="minDate$ | async" [max]="maxDate$ | async" [Datepicker]="pickerAsAt"
        [placeholder]="'Day Month Year'" (ngModelChange)="onChangeTo($event)" [disabled]="!(showData$ | async)"
        [readonly]="true" />
      <atlas-field-suffix>
        <datepicker-toggle [datepicker]="pickerAsAt"></datepicker-toggle>
      </atlas-field-suffix>
      <datepicker #pickerAsAt> </datepicker>
    </atlas-field>

  </ng-container>

  <ng-container *ngIf="!(isMobile$ | async)">
    <atlas-field [widthValue]="270" *dsp-content-filter [id]="'valuations-from-filter'">
      <atlas-field-label>From</atlas-field-label>
      <input [(ngModel)]="from" atlasInput [min]="minDate$ | async" [max]="to" [Datepicker]="pickerFrom"
        [placeholder]="'Day Month Year'" (ngModelChange)="onChangeFrom($event)" [disabled]="!(showData$ | async)"
        [readonly]="true" />
      <atlas-field-suffix>
        <datepicker-toggle [datepicker]="pickerFrom"></datepicker-toggle>
      </atlas-field-suffix>
      <datepicker #pickerFrom> </datepicker>
    </atlas-field>

    <atlas-field [widthValue]="270" *dsp-content-filter [id]="'valuations-to-filter'">
      <atlas-field-label>To</atlas-field-label>
      <input [(ngModel)]="to" atlasInput [min]="from" [max]="maxDate$ | async" [Datepicker]="pickerTo"
        [placeholder]="'Day Month Year'" (ngModelChange)="onChangeTo($event)" [disabled]="!(showData$ | async)"
        [readonly]="true" />
      <atlas-field-suffix>
        <datepicker-toggle [datepicker]="pickerTo"></datepicker-toggle>
      </atlas-field-suffix>
      <datepicker #pickerTo> </datepicker>
    </atlas-field>
  </ng-container>

  <div dsp-content>
    <ng-container *ngIf="!(isMobile$ | async)">
      <div *ngIf="showData$ | async" class="row mos-u-spacer--margin-sm">
        <div class="dsp-buttons-container column">


          <atlas-button-group variant="outlined">
            <button #buttonGroup [style.flex]="1" *ngFor="let option of options" class="dsp-valuations-button"
              type="button" [size]="'small'" variant="text" [active]="option.value===(type$ | async)"
              [class.active-button]="option.value===(type$ | async)" (click)="onChangeType(option.value)">
              {{ option.label }}
            </button>
          </atlas-button-group>
        </div>
      </div>

      <div>
        <div class="row mos-u-spacer--margin-md">
          <div class="dsp-valuations-header-container column">
            <div class="dsp-valuations-header-row">

              <atlas-icon [icon]="'icon-line-chart-24'" [size]="'large'" [color]="'primary'"
                [alt]="'Growth Of Investments'">
              </atlas-icon>
              <ng-container *ngIf="(type$ | async) === 'price'">
                <h3 class="mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
                  Growth Of Investments
                </h3>

                <atlas-icon *ngIf="(notes$ | async)?.valuation[ 'price' ] !== undefined"
                  #valuationPriceTooltip="haloTooltip"
                  (click)="valuationPriceTooltip.toggle(); $event.stopPropagation()"
                  class="mos-u-spacer--margin-left-xxsm dsp-valuations-tooltip-trigger" [haloTooltipWithArrow]="true"
                  [haloTooltip]="(notes$ | async)?.valuation[ 'price' ]"
                  [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
                  [haloTooltipTouchGestures]="'on'"
                  [haloTooltipClass]="(isMobile$ | async) ? 'dsp-valuations-mobile-tooltip' : null"
                  [id]="'valuation-price-note-icon'" [icon]="'c-info'" [collection]="'user-interface'" [size]="'small'"
                  [alt]="'info'">
                </atlas-icon>
              </ng-container>
              <ng-container *ngIf="(type$ | async) === 'unitPrice'">
                <h3 class="mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
                  Unit Price
                </h3>

                <atlas-icon *ngIf="(notes$ | async)?.valuation[ 'price' ] !== undefined"
                  #valuationUnitPriceTooltip="haloTooltip"
                  (click)="valuationUnitPriceTooltip.toggle(); $event.stopPropagation()"
                  class="mos-u-spacer--margin-left-xxsm dsp-valuations-tooltip-trigger" [haloTooltipWithArrow]="true"
                  [haloTooltip]="(notes$ | async)?.valuation[ 'unitPrice' ]"
                  [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
                  [haloTooltipTouchGestures]="'on'"
                  [haloTooltipClass]="(isMobile$ | async) ? 'dsp-valuations-mobile-tooltip' : null"
                  [id]="'valuation-unit-price-note-icon'" [icon]="'c-info'" [collection]="'user-interface'"
                  [size]="'small'" [alt]="'info'">
                </atlas-icon>
              </ng-container>
            </div>
            <div *ngIf="showData$ | async" class="dsp-actions">
              <atlas-dropdown #valuationsDropdown="atlasDropdown" [icon]="'more_vert'"
                [placement]="dropdownPlacementLeftStart" [iconSize]="sizeMedium" [iconSheetUrl]="iconSheetUrl"
                [disabled]="disabled" [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
                [triggerType]="dropdownTriggerTypeIconButton" data-testid="dropdown-playground_955432335">
                <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
                  <atlas-menu-item *ngIf="(type$ | async) === 'price'"
                    (click)="valuationsDropdown.menu?.closeMenu($event); onExportCSV('history')">
                    <a [id]="'valuation-history-export'">
                      Export Growth of Investments History
                    </a>
                  </atlas-menu-item>
                  <atlas-menu-item *ngIf="(type$ | async) === 'unitPrice'"
                    (click)="valuationsDropdown.menu?.closeMenu($event); onExportCSV('unit-price')">
                    <a [id]="'valuation-unit-price-export'">
                      Export Unit Price History
                    </a>
                  </atlas-menu-item>
                  <atlas-menu-item (click)="valuationsDropdown.menu?.closeMenu($event); onExportPDF()">
                    <a [id]="'holdings-donut-download'">
                      Export Investment Details as PDF
                    </a>
                  </atlas-menu-item>
                  <atlas-menu-item (click)="valuationsDropdown.menu?.closeMenu($event); onExportCSV('regular')">
                    <a [id]="'holdings-donut-export'">
                      Export Investment Details as CSV
                    </a>
                  </atlas-menu-item>
                </atlas-menu>
              </atlas-dropdown>

            </div>
          </div>
        </div>
        <div *ngIf="showData$ | async" class="row">
          <div class="columns">
            <div dsp-chart [chart]="chart" class="dsp-chart"></div>
          </div>
        </div>
        <div *ngIf="!(showData$ | async)" class="row">
          <div class="column mos-u-align-center--both" [style.height.px]="300">
            <h3>
              No Data Available
            </h3>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="row mos-u-spacer--margin-top-md">
      <div class="dsp-valuations-header-container column">
        <div class="dsp-valuations-header-row">

          <atlas-icon [icon]="'icon-webpage-24'" [size]="'large'" [color]="'brand'" [alt]="'Growth Of Investments'">
          </atlas-icon>
          <h3 class="mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
            Investment Details
          </h3>

          <atlas-icon *ngIf="(notes$ | async)?.valuation[ 'details' ] !== undefined"
            #valuationDetailsTooltip="haloTooltip" (click)="valuationDetailsTooltip.toggle(); $event.stopPropagation()"
            class="mos-u-spacer--margin-left-xxsm dsp-valuations-tooltip-trigger" [haloTooltipWithArrow]="true"
            [haloTooltip]="(notes$ | async)?.valuation[ 'details' ]"
            [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
            [haloTooltipTouchGestures]="'on'"
            [haloTooltipClass]="(isMobile$ | async) ? 'dsp-valuations-mobile-tooltip' : null"
            [id]="'valuation-details-note-icon'" [icon]="'c-info'" [collection]="'user-interface'" [size]="'small'"
            [alt]="'info'">
          </atlas-icon>
        </div>
      </div>
    </div>
    <div *ngIf="showData$ | async" class="row mos-u-spacer--margin-bottom-md">
      <div class="columns">
        <p class="dsp-date mos-u-spacer--margin-none">
          as at {{ date$ | async }}
        </p>
      </div>
    </div>
    <div *ngIf="!(showData$ | async)" class="row">
      <div class="column mos-u-align-center--both" [style.height.px]="300">
        <h3>
          No Data Available
        </h3>
      </div>
    </div>
    <div *ngIf="showData$ | async" class="row">
      <div class="column">
        <atlas-table class="dsp-valuations-table" [customSort]="true">
          <thead atlas-table-header #header>

            <tr atlas-table-row [border]="true">
              <th atlas-table-header-cell *ngFor="let col of headers$ | async; let i = index" [columnDef]="col"
                [style.text-align]="i > 0 ? 'right' : 'left'" (click)="onSort(col.column,header.sortOption.direction)">
                {{ col.name }}
              </th>
            </tr>
          </thead>
          <tbody atlas-table-body>
            <tr halo-table-row [border]="true" *ngFor="let row of table$ | async"
              [class.total-portfolio-row]="row.name === 'Total Portfolio'">

              <td atlas-table-cell [ngClass]="{ 'dsp-highlight dsp-highlight-border' : row.selected }">
                {{ !!row.name ? row.name : '-' }}
              </td>
              <td atlas-table-cell [ngClass]="{ 'dsp-highlight' : row.selected }" class="mos-u-text-right ">
                {{ !!row.price ? (row.price | decimal) : '-' }}
              </td>
              <td atlas-table-cell [ngClass]="{ 'dsp-highlight' : row.selected }" class="mos-u-text-right ">
                {{ !!row.units ? (row.units | decimal) : '-' }}
              </td>
              <td atlas-table-cell [ngClass]="{ 'dsp-highlight' : row.selected }" class="mos-u-text-right ">
                {{ !!row.latestValuation ? row.latestValuation : '-' }}
              </td>
              <td atlas-table-cell [ngClass]="{ 'dsp-highlight' : row.selected }" class="mos-u-text-right ">
                {{ !!row.closing ? (row.closing | decimal) : '-' }}
              </td>
              <td atlas-table-cell [ngClass]="{ 'dsp-highlight' : row.selected }" class="mos-u-text-right ">
                {{ !!row.actual ? (row.actual | decimal) : '-' }}
              </td>
              <td atlas-table-cell *ngIf="(showRangeStrategic$ | async)" [ngClass]="{ 'dsp-highlight' : row.selected }"
                class="mos-u-text-right ">
                {{ !!row.strategic ? (row.strategic | decimal) : '-' }}
              </td>
              <td atlas-table-cell *ngIf="(showRangeStrategic$ | async)" [ngClass]="{ 'dsp-highlight' : row.selected }"
                class="mos-u-text-right ">
                {{ !!row.range ? row.range : '-' }}
              </td>

            </tr>
          </tbody>
        </atlas-table>
        <div class="column medium-3 pagination-container" style="justify-content: left;">
          <ng-container *ngIf="table$ | async as tableRows">
            <span>
              Showing 1 to {{ tableRows.length - 1 }} of {{ tableRows.length - 1 }} entries
            </span>
          </ng-container>
        </div>
        <!-- <div *ngIf="!!(pagination$ | async)" class="mos-u-spacer--margin-top-md">
          <atlas-pagination [paginationInfo]="pagination$ | async">
          </atlas-pagination>
        </div> -->
      </div>
    </div>
  </div>
</dsp-content-card>